import { Component, OnInit, ViewChild } from "@angular/core";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { Condition } from "src/app/models/custom-types";
import { MovimientosDTO } from "src/app/models/dto/movimientos.dto";
import { FilterEvent } from "src/app/models/filter";
import { ListColumn } from "src/app/models/list-columns.model";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { Filter } from "src/app/shared/classes/filter";
import { UnidadForm } from "./form/form.component";
import { UnidadesService } from "./movements.service";

@Component({
  selector: "app-movements",
  templateUrl: "./movements.component.html",
  styles: [],
})
export class MovementsComponent implements OnInit {
  public columns: ListColumn[] = [
    {
      name: "Folio",
      property: "Folio",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "# Interno",
      property: "NoParteInterno",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Desc",
      property: "Descripcion",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Entrada",
      property: "Entrada",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Salida",
      property: "Salida",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Saldo",
      property: "Saldo",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Razon",
      property: "Razon",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "NoFactura",
      property: "NoFactura",
      visible: true,
      isModelProperty: true,
    },
  ];
  @ViewChild(CardTableComponent, { static: true })
  public tableComp: CardTableComponent;

  @ViewChild(UnidadForm, { static: true })
  public formulario: UnidadForm;
  realdata: MovimientosDTO[] = [];
  constructor(
    public service: UnidadesService,
    private alerts: AlertasSwalService
  ) {}

  ngOnInit(): void {
    this.loadRecords();
    this.filter = new Filter<MovimientosDTO>(
      this.conditions,
      this.columns,
      true
    );
  }

  loadRecords() {
    this.service.get().subscribe(
      (resultData) => {
        this.realdata = resultData;
        this.filter.setDataTable(this.realdata, this.tableComp);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  //#region Filter

  public filter: Filter<MovimientosDTO>;
  public conditions: Condition<MovimientosDTO> = {
    Descripcion: (o, f) => o.Descripcion.toLocaleLowerCase().indexOf(f) > -1,
    NoParteInterno: (o, f) =>
      o.NoParteInterno.toLocaleLowerCase().indexOf(f) > -1,
    Razon: (o, f) => o.Razon.toLocaleLowerCase().indexOf(f) > -1,
  };

  filterdata(e: FilterEvent) {
    this.filter.filterdata(e, this.realdata, this.tableComp);
  }

  //#endregion Filter
}
